import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";
import axAPI from "../../../api/axios-instance";
import { DataProvider } from "@refinedev/core";
import qs from "qs";

export const clubsBackgroundDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = axAPI
): DataProvider =>
  <IDataContextProvider>{
    create: async ({
      resource,
      variables,
      meta,
    }: {
      resource: string;
      variables: { background: string; leagueId: number; teamId: number };
      meta: {
        teamId: number;
        leagueId: number;
      };
    }) => {
      const updateUrl = "/cms/team/background";
      const { leagueId, teamId } = meta;

      try {
        const { data } = await httpClient.post(updateUrl, {
          ...variables,
        });

        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
    deleteOne: async ({
      resource,
      id,
      meta,
    }: {
      id: number;
      resource: string;
      meta: { leagueId: number; teamId: number };
    }) => {
      const url = "/cms/team/background/delete";
      const { leagueId, teamId } = meta;
      try {
        const { data } = await httpClient.post(
          `${url}?${qs.stringify({ leagueId, teamId })}`
        );
        return {
          data,
        };
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
